import { render } from "./DamageModel.vue?vue&type=template&id=56803ca5&scoped=true"
import script from "./DamageModel.vue?vue&type=script&lang=js"
export * from "./DamageModel.vue?vue&type=script&lang=js"

import "./DamageModel.vue?vue&type=style&index=0&id=56803ca5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56803ca5"

export default script